@import (reference) '../../../../../../../../constants/spacing.module.less';

.quote-card {
  border: 1px solid var(--default--border-color--10);
  border-radius: 4px;
  padding: @space-12 @space-16;
  cursor: pointer;
  transition:
    background 200ms,
    border-color 200ms;
  background: var(--light--background-color--1);
}

.quote-card:hover {
  background: var(--primary--button--hover--background-color--3);
}

.quote-card-selected {
  border: 2px solid #06c;
  margin: -1px;
  background: var(--default--background-color--2);
}

.quote-card-selected:hover {
  background: var(--default--background-color--2);
}

.quote-card-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
}

.carrier-info {
  display: flex;
  flex-flow: column nowrap;
  min-width: 0;
  flex: 1;
}

.carrier-name-row {
  display: flex;
  align-items: center;
}

.carrier-name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 600;
}

.service-name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: var(--default--text-color--9);
}

.price-info {
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-end;
  flex-shrink: 0;
}

.total-charges {
  font-weight: 600;
}

.transit-info {
  display: flex;
  flex-flow: column nowrap;
  color: var(--default--text-color--9);
}

.quote-card-guaranteed {
  display: inline-flex;
  align-items: center;
  padding: @space-0 @space-8;
  border-radius: 4px;
  background: #28a745;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;
}

.quote-card-footer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
